import React, { ReactNode } from 'react';
import { useStyles } from './list-item.styles';

export function ListItem({ children, size = 'medium' }: { children: ReactNode; size?: 'small' | 'medium' | 'large' }) {
	const { classes } = useStyles({ size });

	return <li className={classes.root}>{children}</li>;
}
